import { TOOL_GROUPS } from "../tools-config";
import { cn } from "../../../lib/utils";

/**
 * Vertical icon-only tool rail. Every tool has title + aria-label + tooltip.
 */
export default function EditorToolRail({ mode, selectedTool, onSelect, collapsed }) {
  if (collapsed) return null;

  const visibleGroups = TOOL_GROUPS
    .map((group) => ({
      ...group,
      tools: group.tools.filter((t) => t.modes.includes(mode)),
    }))
    .filter((group) => group.tools.length > 0);

  return (
    <div
      data-testid="editor-tool-rail"
      className="w-12 shrink-0 border-r border-[var(--pl-border)] bg-[var(--pl-surface)]/70 backdrop-blur-md py-2 overflow-y-auto pl-noscroll"
      style={{ height: "100%" }}
    >
      <div className="flex flex-col items-center gap-1">
        {visibleGroups.map((group, gi) => (
          <div key={group.id} className="w-full">
            {group.tools.map((t) => {
              const I = t.icon;
              const Active = selectedTool === t.id;
              return (
                <div key={t.id} className="relative group px-1.5 py-0.5">
                  <button
                    data-testid={`tool-${t.id}`}
                    title={t.label}
                    aria-label={t.label}
                    aria-pressed={Active}
                    onClick={() => onSelect(t.id)}
                    className={cn(
                      "w-9 h-9 rounded-lg grid place-items-center transition",
                      Active
                        ? "bg-[var(--pl-aqua)]/20 text-[var(--pl-aqua)] ring-1 ring-[var(--pl-aqua)]/40"
                        : "text-[var(--pl-text-muted)] hover:text-[var(--pl-text)] hover:bg-white/5"
                    )}
                  >
                    <I className="h-4 w-4" strokeWidth={1.7} />
                  </button>
                  <div
                    role="tooltip"
                    className="pointer-events-none absolute left-full top-1/2 -translate-y-1/2 ml-2 whitespace-nowrap rounded-md border border-[var(--pl-border)] bg-black/85 px-2 py-1 text-[10px] uppercase tracking-[0.18em] text-[var(--pl-aqua)] opacity-0 group-hover:opacity-100 transition z-50"
                  >
                    {t.label}
                  </div>
                </div>
              );
            })}
            {gi < visibleGroups.length - 1 && (
              <div className="my-1 mx-3 h-px bg-[var(--pl-border)]" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
